import React, { FC, Suspense, useMemo } from 'react';
import { Form, FormikProvider } from 'formik';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from 'components/UI/Buttons/buttons';
import Input from 'components/UI/Input/input';
import Card from 'components/UI/Card';
import { FiAlertCircle } from 'react-icons/fi';
import { ReactComponent as ShowPassSvg } from '../../../assets/show_pass.svg';
import { ReactComponent as HidePassSvg } from '../../../assets/hide_pass.svg';
import css from '../styles.module.scss';
import { useChangePasswordDetail } from '../hooks/useChangePasswordDetail';

const ChangePassword: FC = () => {
  const { t } = useTranslation();

  const {
    error,
    isLoading,
    formikContext,
    submitCount,
    touched,
    errors,
    values,
    handleChange,
    handleBlur,
    formFields,
    openPass,
    handleToggleOpenPass,
  } = useChangePasswordDetail();

  return (
    <>
      <Card noHover className={css.form__card}>
        <FormikProvider value={formikContext}>
          <Form className={css.form__block}>
            <h1 className={css.form__title}>
              {t('login_page.changeYourPass')}
            </h1>
            {!!error.length && (
              <div className={css.form__error}>
                <Suspense fallback={<></>}>
                  <FiAlertCircle size={20} />
                </Suspense>
                <span>{error}</span>
              </div>
            )}
            {formFields.map((key) => {
              const icon = useMemo(() => {
                if (!values[key]) return <></>;

                return openPass[key] ? (
                  <HidePassSvg onClick={() => handleToggleOpenPass(key)} />
                ) : (
                  <ShowPassSvg onClick={() => handleToggleOpenPass(key)} />
                );
              }, [values[key], openPass[key]]);

              return (
                <div className={css.form__pass}>
                  <Input
                    key={key}
                    label={t(`form.common.${key}`)}
                    icon={icon}
                    icon_classname={css.form__pass_icon}
                    error={!!submitCount && !!touched[key] && !!errors[key]}
                    errortext={errors[key]}
                    inputAttributes={{
                      type: openPass[key] ? 'text' : 'password',
                      value: values[key],
                      name: key,
                      onChange: handleChange,
                      onBlur: handleBlur,
                      placeholder: t(
                        `campaigns_page.campaign_settings.Please_enter`,
                      ),
                    }}
                  />
                </div>
              );
            })}
            <Button
              title={t('form.common.saveChanges')}
              buttonAttributes={{
                type: 'submit',
                style: {
                  fontWeight: 700,
                  marginTop: 16,
                },
                disabled: isLoading,
              }}
            />
          </Form>
        </FormikProvider>
      </Card>
      <div className={css.form__new}>
        <span> {t('form.common.have_acc')} </span>
        <Link to="/auth/sign-in">{t('form.common.signin')}</Link>
      </div>
    </>
  );
};

export default ChangePassword;
